import Status from '../../../../enums/Status';
import * as KlarnaApi from '../../../api/klarna-api';
import {placeOrderViaApiPoller} from '../../../api/pollers/pollers';
import {TooltipAndOverlayIDs} from '../../../components/detailed-tooltip/TooltipLibrary';
import page from '../../../page/page';
import KlarnaSDK from '../../../sdks/KlarnaSDK';
import {
  getCustomerDetailsInKlarnaSDKFormat,
} from '../../../selectors/PaymentOptionSelectors/Klarna/KlarnaSelectors';
import {getUsedDeliveryAddressOnPaymentResolutionPageInAPIFormat} from '../../../selectors/PaymentResolutionSelectors';
import {
  getSelectedAddressInAPIFormat,
} from '../../../selectors/selectors';
import attributes from '../../../tracking/attributes';
import doMetric from '../../../tracking/bigQueryMetricRecorder';
import Track from '../../../utils/tracking';
import {setShouldPauseFocusTrap, showOverlay} from '../../overlay-actions';
import {startOrderProcessing, stopOrderProcessing} from '../../site-actions';
import createAuthBodyAndShippingAddressForAuthorizeKlarna from './createAuthBodyAndShippingAddressForAuthorizeKlarna';
import handleKlarnaError from './handleKlarnaError';
import {setAuthKlarnaCategoryResponse, setKlarnaStatus} from './klarna-actions';

const doAuthMetric = (attribute) => {
  try {
    doMetric('klarnaAuthorisation', attribute);
  } catch (error) {
    Track.track(error);
  }
};

// Get Basket Information from API
export default category => (dispatch, getState) => {
const address = !page.isOnPage('payment-resolution') ?
  getSelectedAddressInAPIFormat(getState()) : getUsedDeliveryAddressOnPaymentResolutionPageInAPIFormat(getState())
return dispatch(KlarnaApi.getKlarnaInformation(address))
  .then((klarnaInformation) => {
    // Pass Information to Klarna via SDK
    dispatch(setKlarnaStatus(Status.PLACING_ORDER));
    dispatch(setShouldPauseFocusTrap(true));
    
    const {authRequestBody, shippingAddressInAPIFormat} = createAuthBodyAndShippingAddressForAuthorizeKlarna(dispatch, getState)(klarnaInformation);
    
    return KlarnaSDK.authorize(category, authRequestBody)
      .then((klarnaSDKResult) => {
        dispatch(setAuthKlarnaCategoryResponse(category, klarnaSDKResult));
        dispatch(setShouldPauseFocusTrap(false));
        const hasAuthErrors = !!klarnaSDKResult.error?.invalid_fields;
        
        const bqAttributes = [
          {name: 'approved', value: klarnaSDKResult.approved},
          {name: 'show_form', value: klarnaSDKResult.show_form},
        ];
        
        if (hasAuthErrors) {
          klarnaSDKResult.error?.invalid_fields.length > 0 && klarnaSDKResult.error?.invalid_fields.forEach((error, index) => bqAttributes.push({
            name: `klarnaError-${index}`,
            value: error,
          }));
        }
  
        doAuthMetric(bqAttributes);
        
        // Handle SDK Result
        if (klarnaSDKResult.approved) {
          doAuthMetric([attributes.getAttribute('status', 'APPROVED')]);
        } else {
          dispatch(setKlarnaStatus(Status.SUCCESS));
          if (klarnaSDKResult.show_form) {
            doAuthMetric([attributes.getAttribute('status', 'RECOVERABLE')]);
            dispatch(stopOrderProcessing(false))
            return dispatch(showOverlay(TooltipAndOverlayIDs.KLARNA, {messageKey: 'errors.placeOrderFailError'}));
          } else {
            doAuthMetric([attributes.getAttribute('status', 'REJECTED')]);
            return dispatch(stopOrderProcessing(false));
          }
        }
        
        // Pass SDK Result and other required information to API
        return dispatch(KlarnaApi.setKlarnaAuthorised(klarnaSDKResult, klarnaInformation,
          shippingAddressInAPIFormat, shippingAddressInAPIFormat, getCustomerDetailsInKlarnaSDKFormat(getState())))
          .then(() => {
            dispatch(startOrderProcessing());
            placeOrderViaApiPoller.runPoller();
          })
          .catch((error) => {
            dispatch(handleKlarnaError('KLARNA_SET_API_AUTHORISATION_STATUS_FAILED', error));
            doAuthMetric([{name: 'setAuth', value: 'failed'}]);
          });
      })
      .catch((error) => {
        dispatch(handleKlarnaError('KLARNA_AUTHORISE_FAILED', error));
        doAuthMetric([{name: 'authCall', value: 'failed'}]);
        dispatch(setShouldPauseFocusTrap(false));
      });
  })
  .catch((error) => {
    dispatch(handleKlarnaError('KLARNA_INFORMATION_FAILED', error));
    doAuthMetric([{name: 'infoCall', value: 'failed'}]);
    dispatch(setShouldPauseFocusTrap(false));
  });
};
